import { createRoutine } from 'redux-saga-routines'

export const SET = 'LAYOUT_DATA/SET'
export const LOAD = createRoutine('LAYOUT_DATA/LOAD')
